import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/pages/main'
import Home from '@/pages/meta/home'
import Group from '@/pages/meta/group'
import Personal from '@/pages/meta/personal'
import HeightLight from '@/pages/meta/highlight'
import SeniorEN from '@/pages/meta/senior-en'
import JuniorEN from '@/pages/meta/junior-en'
import ChildrenEN from '@/pages/meta/children-en'
import ChildrenJA from '@/pages/meta/children-ja'
import NewStudy from '@/pages/meta/newstudy'
import LiveMain from '@/pages/meta/livemain'
import Profile from '@/pages/meta/profile'
import CourseIn from '@/pages/other-page/course-in'
import NewStudyIn from '@/pages/other-page/newstudy-in'

import Live from '@/pages/other-page/live'
// import notfound from '@/pages/404'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    //- 主畫面
    {
      path: '/student/main',
      name: 'main',
      component: Main,
    },
    //- 控制台畫面
    {
      path: '/student',
      components: {
        default: Main,
        view: Home,
      },
      children: [
        // home
        {
          path: 'home',
          name: 'home',
          component: Home,
        },
        // group
        {
          path: 'group',
          name: 'group',
          component: Group,
        },
        // personal
        {
          path: 'personal',
          name: 'personal',
          component: Personal,
        },
        // live-main
        {
          path: 'live_main',
          name: 'live_main',
          component: LiveMain,
        },
        // highlight
        {
          path: 'highlight',
          name: 'highlight',
          component: HeightLight,
        },
        // senior
        {
          path: 'senior',
          name: 'senior',
          component: SeniorEN,
        },
        // junior
        {
          path: 'junior',
          name: 'junior',
          component: JuniorEN,
        },
        // children_en
        {
          path: 'children_en',
          name: 'children_en',
          component: ChildrenEN,
        },
        // children_ja
        {
          path: 'children_ja',
          name: 'children_ja',
          component: ChildrenJA,
        },




        // new_study
        {
          path: 'new_study',
          name: 'new_study',
          component: NewStudy,
        },
        // profile
        {
          path: 'profile',
          name: 'profile',
          component: Profile,
        },
        // 新生學園內頁
        {
          path: 'new_study/:new_study_id',
          name: 'new_study_in',
          component: NewStudyIn,
        },
        // 課程內頁
        {
          path: 'course/:course_id',
          name: 'course',
          component: CourseIn,
        },
        // 課程內頁
        {
          path: 'live/:course_id',
          name: 'live',
          component: Live,
        },
      ]
    },
    {
      path: '*',
      redirect: '/student/main'
    },
  ]
})
